import type { Name } from "./area.types";

const removeIncorrectSymbols = (name: Name): Name =>
  name.replace(/[^\w-]/gi, "-").replace(/-{2,}/g, "-");

export const getGridArea = (name: Name): Name => removeIncorrectSymbols(name);
